'use strict'

import $ from 'jquery';

const availableSizes = ['1','2','3']; // Array of strings
const defaultSize = '2'; // Size class (css) will be removed if using this size

var textSize = {
  setSize(size){

    // Validate size, convert to string
    size = (['number','string'].indexOf(typeof size) > -1 ? size.toString() : ''); // force to string
    if(availableSizes.indexOf(size) < 0){
      // Not valid > return;
      return;
    }
    // Good to go..

    localStorage.setItem('textSize', size);

    $('.page-content')
    .removeClass(function(index, className){
      return (className.match(/(^|\s)page-content--text-size-\S+/g) || []).join(' ');
    })
    .toggleClass('page-content--text-size-'+size, size !== defaultSize); // add new class only if not using the defaultSize

    $('[data-set-text-size].selected').removeClass('selected'); // clear selected states
    $('[data-set-text-size="'+size+'"]').addClass('selected'); // set select state

    return size;
  },

  init(){
    const self = this;
    const size = (localStorage.getItem('textSize') ? localStorage.getItem('textSize') : defaultSize);

    // Set text size
    this.setSize(size);

    // Add click event listener for all elements with data-set-text-size attribute.
    $('[data-set-text-size]').on('click', function(evt){
      evt.preventDefault();
      evt.stopPropagation();
      const $this = $(this);
      const size = $this.data('set-text-size');
      self.setSize(size);
    })
  }
}

module.exports = textSize;
